import { z } from 'zod'

/**
 * Contrato da API de documentos do Portal do Cliente para o Via Tax (F2, arquitetura §5.2).
 * O lado do Portal está em portal-via/server/app/routers/viatax.py. Tudo que chega passa
 * por aqui antes de tocar no banco.
 */

export const STATUS_COBERTURA_PORTAL = ['ok', 'atualizando', 'erro', 'aguardando', 'futuro'] as const
export type StatusCoberturaPortal = (typeof STATUS_COBERTURA_PORTAL)[number]

export const MesCoberturaPortal = z.object({
  status: z.enum(STATUS_COBERTURA_PORTAL),
  qtd: z.number().int().nullable(),
  atualizado_em: z.string().nullable(),
  mensagem: z.string().nullable(),
})

export const CoberturaPortal = z.object({
  empresas: z.array(
    z.object({
      cnpj: z.string(),
      razao_social: z.string().nullable(),
      competencias: z.record(z.string().regex(/^\d{4}-\d{2}$/), MesCoberturaPortal),
    }),
  ),
  enfileirados: z.number().int(),
})
export type CoberturaPortal = z.infer<typeof CoberturaPortal>

export const DocumentoPortal = z.object({
  chave: z.string().min(1).max(60),
  cnpj_empresa: z.string(),
  papel: z.string(),
  tipo: z.string().nullable(),
  modelo: z.string().nullable(),
  data: z.string().nullable(),
  cancelada: z.boolean(),
  /** XML da nota em base64; nulo se o Portal não tiver o XML guardado */
  xml_b64: z.string().nullable(),
  /** XML do evento de cancelamento em base64, quando cancelada */
  evento_cancelamento_b64: z.string().nullable(),
})
export type DocumentoPortal = z.infer<typeof DocumentoPortal>

export const PaginaDocumentosPortal = z.object({
  itens: z.array(DocumentoPortal),
  cursor: z.string().nullable(),
  fim: z.boolean(),
})
export type PaginaDocumentosPortal = z.infer<typeof PaginaDocumentosPortal>

/** Situação da sincronização de uma empresa, como a tela mostra. */
export const STATUS_SINCRONIZACAO_PORTAL = ['nunca', 'sincronizando', 'ok', 'erro'] as const
export type StatusSincronizacaoPortal = (typeof STATUS_SINCRONIZACAO_PORTAL)[number]
